/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpgatesAddonUninstallRequest
 */
export interface UpgatesAddonUninstallRequest {
    /**
     * 
     * @type {string}
     * @memberof UpgatesAddonUninstallRequest
     */
    token: string;
    /**
     * 
     * @type {number}
     * @memberof UpgatesAddonUninstallRequest
     */
    version: number;
    /**
     * 
     * @type {string}
     * @memberof UpgatesAddonUninstallRequest
     */
    time: string;
    /**
     * 
     * @type {string}
     * @memberof UpgatesAddonUninstallRequest
     */
    signatureV2: string;
}

/**
 * Check if a given object implements the UpgatesAddonUninstallRequest interface.
 */
export function instanceOfUpgatesAddonUninstallRequest(value: object): value is UpgatesAddonUninstallRequest {
    if (!('token' in value) || value['token'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    if (!('time' in value) || value['time'] === undefined) return false;
    if ((!('signatureV2' in (value as Record<string, any>)) && !('signature_v2' in (value as Record<string, any>))) || ((value as Record<string, any>)['signatureV2'] === undefined && (value as Record<string, any>)['signature_v2'] === undefined)) return false;
    return true;
}

export function UpgatesAddonUninstallRequestFromJSON(json: any): UpgatesAddonUninstallRequest {
    return UpgatesAddonUninstallRequestFromJSONTyped(json, false);
}

export function UpgatesAddonUninstallRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpgatesAddonUninstallRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'],
        'version': json['version'],
        'time': json['time'],
        'signatureV2': json['signature_v2'],
    };
}

export function UpgatesAddonUninstallRequestToJSON(json: any): UpgatesAddonUninstallRequest {
    return UpgatesAddonUninstallRequestToJSONTyped(json, false);
}

export function UpgatesAddonUninstallRequestToJSONTyped(value?: UpgatesAddonUninstallRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'token': value['token'],
        'version': value['version'],
        'time': value['time'],
        'signature_v2': value['signatureV2'],
    };
}

